export default class RolloutSampleFailureDTO {

    public physicalSampleId: number;
    public macAddress: string;
    public errorMessage?: string;
    public occurredAt?: string;

    constructor(data: { [key: string]: any }) {
        this.physicalSampleId = data['physicalSampleId'];
        this.macAddress = data['macAddress'];
        this.errorMessage = data['errorMessage'];
        this.occurredAt = data['occurredAt'];
    }
}
